<div class="container-fluid">
  <h2 class="ms-0 my-4 fw-bold text-dark">Current Features</h2>
  <div class="row row-cols-1 row-cols-md-4 row-cols-lg-5 g-1 mb-2 features-container">
    <div
      [ngStyle]="{ 'pointer-events': feature.disabled ? 'none' : 'auto' }"
      *ngFor="let feature of features"
      tabindex="0"
      [attr.aria-label]="feature.name"
      (click)="!feature.disabled && navigateToFeature(feature.route)"
      (keydown.enter)="!feature.disabled && navigateToFeature(feature.route)"
      (keydown.space)="!feature.disabled && navigateToFeature(feature.route)"
    >
      <div class="d-flex">
        <div
          class="card shadow-sm border border-secondary d-flex flex-column justify-content-between feature-card w-100 mb-3"
        >
          <div class="card-body px-2 py-2 text-start">
            <div class="mb-3 ms-1 mt-4">
              <nr-icon
                [name]="feature.image"
                sizeClass="icon-size-65 text-warning"
              ></nr-icon>
            </div>
            <h3 class="h5 card-title mt-2 ms-1 fw-semibold">{{ feature.name }}</h3>
            <p class="card-text small text-muted text-wrap mt-3 px-1">
              {{ feature.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
